import { atom } from 'recoil';

export const selectedFees = atom({
  key: 'selectedFees',
  default: undefined,
});
